const { debounce, getElement } = window.BAO.Utils

class FormValidation extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.formDisabled = false
    this.restoreInputValues()
    this.checkRequiredState()
  }

  setupListeners () {
    super.setupListeners()

    this.validateAndPreserveInput = this.validateAndPreserveInput.bind(this)
    if (this?.els?.required?.exists && this?.els?.submit?.exists) {
      this.els.required.elements.forEach(requiredEl => {
        this.listeners.add(
          requiredEl,
          'input',
          debounce(this.validateAndPreserveInput, 750),
        )
      })
    }

    this.handleMaidenNameInput = this.handleMaidenNameInput.bind(this)
    if (this?.els?.maidenNameInput?.exists) {
      this?.els?.maidenNameInput?.elements.forEach(input => {
        input.addEventListener('input', this.handleMaidenNameInput)
      })
    }
  }

  handleMaidenNameInput (e) {
    const inputValue = e.target?.value
    if (inputValue && inputValue.length > 0) {
      this.disableForm()
    }
  }

  disableForm () {
    this.formDisabled = true

    // Disable submit
    if (this?.els?.submit?.exists) {
      this.els.submit.element.ariaDisabled = true
      this.els.submit.element.disabled = true
    }

    // Disable form and prevent submit event
    const form = getElement('form', {
      context: this,
    })
    if (form) {
      form.setAttribute('disabled', 'disabled')
      form.addEventListener('submit', e => {
        e.preventDefault()
      })
    }
  }

  validateAndPreserveInput (input) {
    if (this.formDisabled) return

    this.validateInput(input)
    this.preserveInputValues(input.target)
    this.checkRequiredState()
  }

  validateInput (input) {
    const form = input.target.form

    // We only want to run our own validation if the form has a novalidate attribute.
    if (!form.noValidate) return

    const { target: inputField } = input

    if (inputField.type === 'email') {
      if (!inputField.validity.valid) {
        inputField.setAttribute('aria-invalid', true)
        inputField.setAttribute(
          'aria-errormessage',
          window.theme.strings.invalidEmail,
        )
      } else {
        inputField.removeAttribute('aria-invalid')
        inputField.removeAttribute('aria-errormessage')
      }

      inputField.reportValidity()
    }
  }

  checkRequiredState () {
    let allAreFilled = true

    if (this?.els?.required?.exists) {
      this.els.required.elements.every(requiredEl => {
        if (requiredEl.type === 'text' && requiredEl.value.length === 0) {
          allAreFilled = false

          return false
        }

        if (requiredEl.type === 'email') {
          if (requiredEl.value.length === 0 || !requiredEl.validity.valid) {
            allAreFilled = false

            return false
          }
        }

        if (requiredEl.type === 'password' && requiredEl.value.length === 0) {
          allAreFilled = false

          return false
        }

        if (requiredEl.type === 'checkbox' && requiredEl.checked !== true) {
          allAreFilled = false

          return false
        }

        return true
      })
    }

    if (this?.els?.submit?.exists) {
      this.els.submit.element.ariaDisabled = !allAreFilled
      this.els.submit.element.disabled = !allAreFilled
    }
  }

  preserveInputValues (element) {
    // Save the input value to the session storage.
    if (element.type === 'text' || element.type === 'email') {
      window.sessionStorage.setItem(`BAO-${element.name}`, element.value)
    }
  }

  restoreInputValues () {
    // Restore the input value from the session storage.
    if (this?.els?.required?.exists) {
      this.els.required.elements.forEach(requiredEl => {
        // Only restore if the input is invalid.
        if (requiredEl.validity.valid) {
          // Wipe the stored value.
          window.sessionStorage.removeItem(`BAO-${requiredEl.name}`)

          return
        }

        if (requiredEl.type === 'text' || requiredEl.type === 'email') {
          const value = window.sessionStorage.getItem(`BAO-${requiredEl.name}`)
          if (value) {
            requiredEl.value = value
          }
        }
      })
    }
  }
}

customElements.define('form-validation', FormValidation)
